const FeijoaDisplayFontFamily = [
  'Feijoa-Display',
  'Palatino Linotype',
  'Book Antiqua',
  'serif'
]
const MontserratFontFamily = [
  'Montserrat',
  'Helvetica Neue',
  'Helvetica',
  'Arial',
  'sans-serif'
]
const GeistFontFamily = [
  'Geist',
  'Helvetica Neue',
  'Helvetica',
  'Arial',
  'sans-serif'
]
const FoundersGroteskXCondensedFontFamily = [
  'FoundersGroteskXCondensed',
  'Helvetica Neue',
  'Helvetica',
  'Arial',
  'sans-serif'
]

module.exports = {
  display: FeijoaDisplayFontFamily,
  displayAlt: FoundersGroteskXCondensedFontFamily,
  body: MontserratFontFamily,
  sans: MontserratFontFamily,
  bodyRebrand: GeistFontFamily
}
